<div class="public-adoption-page">

    <div class="form-container">
  
      <!-- =========================
           HEADER
      ========================== -->
  
      <div class="form-header">
        <div class="form-icon">🐾</div>
  
        <h1>Formulario de adopción</h1>
  
        <p>
          Completa la siguiente información para registrar
          el proceso de adopción con ABAQ.
        </p>
      </div>
  
  
      @if (submitted) {
  
        <!-- =========================
             SUCCESS
        ========================== -->
  
        <div class="success-message">
  
          <div class="success-icon">
            ✓
          </div>
  
          <h2>¡Formulario enviado correctamente!</h2>
  
          <p>
            Hemos recibido la información de la adopción.
            El equipo de ABAQ revisará los datos registrados.
          </p>
  
        </div>
  
      } @else {
  
        <form
          #adoptionForm="ngForm"
          (ngSubmit)="submitForm()"
        >
  
          <!-- =========================
               RESPONSABLE
          ========================== -->
  
          <section class="form-section">
  
            <div class="section-title">
              <span class="section-number">1</span>
  
              <div>
                <h2>Información del responsable</h2>
                <p>
                  Datos de la persona que realizará la adopción.
                </p>
              </div>
            </div>
  
  
            <div class="form-grid">
  
              <div class="form-group full-width">
                <label for="responsibleName">
                  Nombre completo *
                </label>
  
                <input
                  id="responsibleName"
                  type="text"
                  name="responsibleName"
                  [(ngModel)]="responsibleName"
                  placeholder="Nombre completo"
                  required
                />
              </div>
  
  
              <div class="form-group">
  
                <label for="responsibleAge">
                  Edad
                </label>
  
                <input
                  id="responsibleAge"
                  type="number"
                  name="responsibleAge"
                  [(ngModel)]="responsibleAge"
                  min="0"
                  placeholder="Edad"
                />
  
              </div>
  
  
              <div class="form-group">
  
                <label for="responsibleGender">
                  Género
                </label>
  
                <input
                  id="responsibleGender"
                  type="text"
                  name="responsibleGender"
                  [(ngModel)]="responsibleGender"
                  placeholder="Género"
                />
  
              </div>
  
            </div>
  
          </section>
  
  
          <!-- =========================
               DOMICILIO
          ========================== -->
  
          <section class="form-section">
  
            <div class="section-title">
              <span class="section-number">2</span>
  
              <div>
                <h2>Domicilio</h2>
                <p>
                  Información del lugar donde vivirá el animal.
                </p>
              </div>
            </div>
  
  
            <div class="form-grid">
  
              <div class="form-group full-width">
  
                <label for="street">
                  Calle y número
                </label>
  
                <input
                  id="street"
                  type="text"
                  name="street"
                  [(ngModel)]="street"
                  placeholder="Calle y número"
                />
  
              </div>
  
  
              <div class="form-group">
  
                <label for="neighborhood">
                  Colonia
                </label>
  
                <input
                  id="neighborhood"
                  type="text"
                  name="neighborhood"
                  [(ngModel)]="neighborhood"
                  placeholder="Colonia"
                />
  
              </div>
  
  
              <div class="form-group">
  
                <label for="municipality">
                  Municipio
                </label>
  
                <input
                  id="municipality"
                  type="text"
                  name="municipality"
                  [(ngModel)]="municipality"
                  placeholder="Municipio"
                />
  
              </div>
  
            </div>
  
          </section>
  
  
          <!-- =========================
               CONTACTO
          ========================== -->
  
          <section class="form-section">
  
            <div class="section-title">
              <span class="section-number">3</span>
  
              <div>
                <h2>Información de contacto</h2>
                <p>
                  Datos para poder comunicarnos con el responsable.
                </p>
              </div>
            </div>
  
  
            <div class="form-grid">
  
              <div class="form-group">
  
                <label for="email">
                  Correo electrónico
                </label>
  
                <input
                  id="email"
                  type="email"
                  name="email"
                  [(ngModel)]="email"
                  placeholder="correo@ejemplo.com"
                />
  
              </div>
  
  
              <div class="form-group">
  
                <label for="phone">
                  Teléfono
                </label>
  
                <input
                  id="phone"
                  type="tel"
                  name="phone"
                  [(ngModel)]="phone"
                  placeholder="Número de teléfono"
                />
  
              </div>
  
  
              <div class="form-group">
  
                <label for="recoveryFee">
                  Cuota de recuperación
                </label>
  
                <div class="input-with-prefix">
  
                  <span>$</span>
  
                  <input
                    id="recoveryFee"
                    type="number"
                    name="recoveryFee"
                    [(ngModel)]="recoveryFee"
                    min="0"
                    placeholder="0"
                  />
  
                </div>
  
              </div>
  
            </div>
  
          </section>
  
  
          <!-- =========================
               ABAQ / REDES
          ========================== -->
  
          <section class="form-section">
  
            <div class="section-title">
              <span class="section-number">4</span>
  
              <div>
                <h2>Información de ABAQ</h2>
                <p>
                  Cuéntanos cómo conociste a ABAQ y sobre tus redes sociales.
                </p>
              </div>
            </div>
  
  
            <div class="form-grid">
  
              <div class="form-group full-width">
  
                <label for="howDidYouHearAboutAbaq">
                  ¿Cómo te enteraste de ABAQ?
                </label>
  
                <input
                  id="howDidYouHearAboutAbaq"
                  type="text"
                  name="howDidYouHearAboutAbaq"
                  [(ngModel)]="howDidYouHearAboutAbaq"
                  placeholder="Evento, redes sociales, recomendado, etc."
                />
  
              </div>
  
  
              <div class="form-group">
  
                <label for="socialNetwork">
                  Red social
                </label>
  
                <input
                  id="socialNetwork"
                  type="text"
                  name="socialNetwork"
                  [(ngModel)]="socialNetwork"
                  placeholder="Instagram, Facebook, TikTok..."
                />
  
              </div>
  
  
              <div class="form-group">
  
                <label for="socialAccount">
                  Cuenta
                </label>
  
                <input
                  id="socialAccount"
                  type="text"
                  name="socialAccount"
                  [(ngModel)]="socialAccount"
                  placeholder="@usuario"
                />
  
              </div>
  
  
              <div class="checkbox-group full-width">
  
                <label class="checkbox-label">
  
                  <input
                    type="checkbox"
                    name="recommendedAbaqOnSocialMedia"
                    [(ngModel)]="recommendedAbaqOnSocialMedia"
                  />
  
                  <span>
                    Recomendaría a ABAQ en redes sociales
                  </span>
  
                </label>
  
              </div>
  
            </div>
  
          </section>
  
  
          <!-- =========================
               ANIMAL
          ========================== -->
  
          <section class="form-section">
  
            <div class="section-title">
              <span class="section-number">5</span>
  
              <div>
                <h2>Información del animal</h2>
                <p>
                  Datos del animal que será adoptado.
                </p>
              </div>
            </div>
  
  
            <div class="form-grid">
  
              <div class="form-group">
  
                <label for="animalName">
                  Nombre del animal *
                </label>
  
                <input
                  id="animalName"
                  type="text"
                  name="animalName"
                  [(ngModel)]="animalName"
                  placeholder="Nombre del animal"
                  required
                />
  
              </div>
  
  
              <div class="form-group">
  
                <label for="species">
                  Especie *
                </label>
  
                <select
                  id="species"
                  name="species"
                  [(ngModel)]="species"
                  required
                >
  
                  <option value="DOG">
                    Perro
                  </option>
  
                  <option value="CAT">
                    Gato
                  </option>
  
                </select>
  
              </div>
  
  
              <div class="form-group">
  
                <label for="animalGender">
                  Género
                </label>
  
                <input
                  id="animalGender"
                  type="text"
                  name="animalGender"
                  [(ngModel)]="animalGender"
                  placeholder="Género"
                />
  
              </div>
  
  
              <div class="form-group">
  
                <label for="breed">
                  Raza
                </label>
  
                <input
                  id="breed"
                  type="text"
                  name="breed"
                  [(ngModel)]="breed"
                  placeholder="Raza"
                />
  
              </div>
  
  
              <div class="form-group">
  
                <label for="size">
                  Tamaño
                </label>
  
                <input
                  id="size"
                  type="text"
                  name="size"
                  [(ngModel)]="size"
                  placeholder="Pequeño, mediano, grande..."
                />
  
              </div>
  
  
              <div class="form-group">
  
                <label for="animalAge">
                  Edad
                </label>
  
                <input
                  id="animalAge"
                  type="number"
                  name="animalAge"
                  [(ngModel)]="animalAge"
                  min="0"
                  placeholder="Edad en años"
                />
  
              </div>
  
  
              <div class="form-group">
  
                <label for="weight">
                  Peso
                </label>
  
                <div class="input-with-suffix">
  
                  <input
                    id="weight"
                    type="number"
                    name="weight"
                    [(ngModel)]="weight"
                    min="0"
                    step="0.1"
                    placeholder="Peso"
                  />
  
                  <span>kg</span>
  
                </div>
  
              </div>
  
  
              <div class="form-group full-width">
  
                <label for="animalPhotoUrl">
                  URL de fotografía
                </label>
  
                <input
                  id="animalPhotoUrl"
                  type="url"
                  name="animalPhotoUrl"
                  [(ngModel)]="animalPhotoUrl"
                  placeholder="https://..."
                />
  
                <small>
                  Si cuentas con una fotografía alojada en línea,
                  puedes agregar su enlace.
                </small>
  
              </div>
  
            </div>
  
          </section>
  
  
          <!-- =========================
               ACTIONS
          ========================== -->
  
          <div class="form-actions">
  
            <p class="required-note">
              * Campos obligatorios
            </p>
  
            <button
              type="submit"
              class="submit-button"
              [disabled]="
                !adoptionForm.valid ||
                isSubmitting
              "
            >
  
              @if (isSubmitting) {
                Enviando formulario...
              } @else {
                Enviar formulario
              }
  
            </button>
  
          </div>
  
        </form>
  
      }
  
    </div>
  
  </div>